const e=["wrap","nowrap","pretty","balance"],r={wrap:{type:"enum",className:"rt-r-tw",values:e,responsive:!0}};export{r as textWrapPropDef};
//# sourceMappingURL=text-wrap.prop.js.map
